import React from 'react';
import { Skeleton } from '@progress/kendo-react-indicators';
import { Card, CardBody } from '@progress/kendo-react-layout';
import { SkeletonButton, SkeletonText } from 'app/components/skeletons';
import './DealerCardSkeleton.less';

export default function DealerCardSkeleton() {
  return (
    <Card className="dealer-card-skeleton">
      <CardBody className="dealer-card-skeleton__body">
        <div className="dealer-card-skeleton__details-column">
          <SkeletonText />
          <SkeletonText className="dealer-card-skeleton__details" />

          <div className="dealer-card-skeleton__actions">
            <SkeletonButton />
            <SkeletonButton />
          </div>
        </div>

        <Skeleton shape="circle" className="dealer-card-skeleton__favorite" />
      </CardBody>
    </Card>
  );
}
